import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Facility } from '../../../../core/models/model';
import { IncidentCategoryService } from '../../../../core/services/incident-category.service';
import { OrganizationUtilService } from '../../../../core/services/organization-util.service';
import _ from 'lodash';
import { ResponseModalComponent } from '../../response-modal/response-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../../core/services/data.service';
import { CameraService } from '../../../../core/services/camera.service';
import * as Cesium from 'cesium';
import { FacilityInfoDialogComponent } from '../../facility-info-dialog/facility-info-dialog.component';
import { DeviceService } from '../../../../core/services/device.service';
import { MultipleMessageComponent } from '../multiple-message/multiple-message.component';
import { OrganizationService } from '../../../../core/services/organization.service';

@Component({
  selector: 'app-facilities-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './facilities-list.component.html',
  styleUrl: './facilities-list.component.css'
})

export class FacilitiesListComponent {

  filteredFacilities: Facility[] = [];
  query = '';
  @ViewChild('searchInput') searchInput!: ElementRef;

  searchQuery: string = '';
  loading: boolean = false;
  error: string | null = null;
  incidentCategoryList: Record<string, any[]> = {};

  @Input() facilityViewId?: string;
  dataItems: any[] = [];
  dataItemsFiltered: any[] = [];
  incidentPermissions: any = {};

  constructor(
    private organizationUtilService: OrganizationUtilService, 
    private incidentCategoryService: IncidentCategoryService,
    private modalService: NgbModal,
    private dataService: DataService,
    private camera: CameraService,
    private deviceService: DeviceService,
    private organizationService: OrganizationService
  ) {}

  private sortFacilities(facilities: any[]): Facility[] {
    return [...facilities].sort((a, b) => 
      (a.label?.toLowerCase() || '').localeCompare(b.label?.toLowerCase() || '')
    );
  }

  onSearch() {
    const query = this.query.trim().toLowerCase();
    if (!query) {
      this.dataItemsFiltered = this.sortFacilities(this.dataItems);
    } else {
      this.dataItemsFiltered = this.sortFacilities(
        this.dataItems.filter(fac =>
          fac.label?.toLowerCase().includes(query)
        )
      );
    }
  }

  ngOnInit() {
    this.setData();
    this.getPanicButtons();
    this.onSearch();
    this.getActionSessionForCreatePerimeter();
  }


  setData() {
    const orgIds = _.map(this.organizationUtilService.myOrgs, 'id'); 

    this.dataItems = [];
    this.dataItemsFiltered = [];

    orgIds.forEach(orgId => {
      const org = _.find(this.organizationUtilService.myOrgs, { id: orgId });
      if (!org) return;

      const entityLocations = typeof org.getEntityLocations === 'function'
        ? org.getEntityLocations()
        : org.entityLocations || [];

      for (const item of entityLocations) {
        if (item.locationType === 'facility') {
          if (this.organizationUtilService.data.myFacilityPins[item.id]) {
            if (this.facilityViewId) {
              if (item.id === this.facilityViewId) {
                this.dataItems.push(item);
                this.dataItemsFiltered.push(item);
                this.organizationUtilService.data.myFacilityPins[item.id].show();
              }
            } else {
              this.dataItems.push(item);
              this.dataItemsFiltered.push(item);
              this.organizationUtilService.data.myFacilityPins[item.id].show();
            }
          }
        }
      }
    });

    this.dataItems = _.orderBy(this.dataItems, ['organizationId'], ['asc']);
    this.dataItemsFiltered = _.orderBy(this.dataItemsFiltered, ['organizationId'], ['asc']);
    this.dataItems = _.uniqBy(this.dataItems, 'buildingId');
    this.dataItemsFiltered = _.uniqBy(this.dataItemsFiltered, 'buildingId');
    this.onSearch();
  }


  orgIsGG(): boolean {
    return false;
  }
  containsBasePerimeter(item: any): boolean {
    if(item.attributes.basePerimeterId && item.attributes.basePerimeterId.length > 0){
      return true;
    }

    return false;
  }

 goToFacility(item: any): void {
  // First switch to 3D monitor mode 
  //this.arcAngelMonitorModeService.goTo3dMonitorMode();  // this function definition code is commented in old angular js
  let entity;
  // Check if it's a bluetooth facility
  if (this.organizationUtilService.data.myBluetoothFacilityPins[item.id]) {
    entity = this.organizationUtilService.data.myBluetoothFacilityPins[item.id];
    entity.viewDetailsWindow(entity);
  } else {
    // Fly to the facility location
    this.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        item.geometry.coordinates[0], 
        item.geometry.coordinates[1], 
        5000
      ),
      complete: () => {
        entity = this.organizationUtilService.data.myFacilityPins[item.id];
        if (entity) {
          entity.viewDetailsWindow(entity);
        }
      }
    });
  }
}

  getFacilityInfo(event: Event, item: Facility) {
    const modalRef = this.modalService.open(FacilityInfoDialogComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.item = item;
  }

  messagePOC(event: Event, item: any): void {
    event.stopPropagation();

    const data: any = { items: [] };

    if (item.attributes.poc) {
      const userIds = _.map(item.attributes.poc, 'userId');

      this.deviceService.getUserProfiles(userIds)
        .then((results) => {
          results = _.uniqBy(results, 'arcAngelId');
          results = _.sortBy(results, 'name');
          _.forEach(results, (result) => {
            data.items.push({ userId: result.arcAngelId, name: result.name });
          });
          data.isNewFormat = true;

          if (data.items.length === 0) {
            this.showAlert('No users to notify');
            return;
          }
          this.openMultipleMessageModal('Send Message', data.items[0] , true)
        })
        .catch((error) => {
          console.error('Error getting user profile.', error);
        });
    } else {
      this.showAlert('The Facility POC is not defined.');
      return;
    }
  }
  public openMultipleMessageModal(
    title: string,
    user: any,
    showCancel: boolean = false
  ) {
    this.organizationService.getProfilesFromOrganization(user.userId).subscribe({
      next: (userInfo: any) => {
        const modalRef = this.modalService.open(MultipleMessageComponent, {
          size: 'md',
          centered: true,      
          backdrop: 'static',
          keyboard:false,
        });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.userInfo = userInfo;
        modalRef.componentInstance.showCancel = showCancel;
        modalRef.componentInstance.users = user; 
        return modalRef.result;
      },
      error: (err: any) => {
        console.error('Error fetching user profile:', err);
      }
    });
  }
  private showAlert(message: string) {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.showCancel = false;
    return modalRef.result;
  }
  getPanicButtons() {
    this.incidentCategoryService.getIncidentCategoryForBuilding().subscribe({
      next: (result: Record<string, any[]>) => {
        this.incidentCategoryList = result;
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

   panicButtonPressed($event: any, item: any, cat: any): void {
    let label = '';
    let id;
    if (cat) {
      label = cat.label;
      id = cat.id;
    }
    this.createIncident(label,item, id);
  }

  firePanicPressed(item: any): void {
    this.createIncident('Fire Emergency',item,  0);
  }
  medicalPanicPressed(item: any): void {
    this.createIncident('Medical Emergency',item,  1);
  }
  policePanicPressed(item: any): void {
    this.createIncident('Police Emergency',item,  2);
  }
  generalPanicPressed(item: any): void {
    this.createIncident('General Emergency',item,  3);
  }
  otherPanicPressed(item: any): void {
    this.createIncident('Other Emergency',item,  4);
  }
   private createIncident(
      label: string,item: any,
      organizationIncidentCategoryId: number
    ): void {
      const perimeterId = item.id;
     if (!this.checkIncidentPermission(perimeterId)) {
        const modalRef = this.modalService.open(ResponseModalComponent, {
          centered: true,
          backdrop: 'static',
          keyboard: false,
        });
        const component = modalRef.componentInstance as ResponseModalComponent;
        component.message =
          'You do not have permission to create incident for this building';
        component.showCancel = false;
        return;
      }
  
      const modalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
      const component = modalRef.componentInstance as ResponseModalComponent;
      component.message = `Are you sure you want to create an active ${label} incident?`;
      component.showCancel = true;
      modalRef.result
        .then((confirmed: boolean) => {
          if (confirmed) {
            this.incidentCategoryService.startFixedPerimeterCreation(
              item?.organizationId,
              perimeterId,
              label,
              undefined,
              true,
              organizationIncidentCategoryId
            );
          }
        })
        .catch(() => {});
    }
    private getActionSessionForCreatePerimeter(): void {
    this.dataService.getActionSessionForCreatePerimeter().subscribe({
      next: (result) => {
        this.incidentPermissions = result;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  private checkIncidentPermission(perimeterId: number): boolean {
    const buildingOrganizationIds =
      this.getBuildingOrganizationIds(perimeterId);

    const privateRows = this.incidentPermissions.privatePerimeter?.rows || [];
    const publicRows = this.incidentPermissions.publicPerimeter?.rows || [];
    const permissions = [...privateRows, ...publicRows];

    let permissionOrgIds: any[] = [];
    permissions.forEach((p: any) => {
      if (Array.isArray(p.organizationIds)) {
        permissionOrgIds = permissionOrgIds.concat(p.organizationIds);
      }
    });

    permissionOrgIds = Array.from(new Set(permissionOrgIds));

    const hasIntersection = buildingOrganizationIds.some((id) =>
      permissionOrgIds.includes(id)
    );
    return hasIntersection;
  }
   private getBuildingOrganizationIds(perimeterId: number): any[] {
    return (this.organizationUtilService.myPerimetersForOrg || [])
      .filter((o: any) => o.perimeterId === perimeterId)
      .map((o: any) => o.organizationId);
  }


}